const moscowDateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export const formatMoscowDateTime = (value: string | null | undefined) => {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime())
    ? '—'
    : moscowDateTimeFormatter.format(date)
}

export const formatRate = (value: number | string | null | undefined) => {
  const rate = typeof value === 'string' ? Number(value) : value
  return typeof rate === 'number' && Number.isFinite(rate)
    ? Number(rate.toFixed(4)).toString()
    : '—'
}
